import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "overflow"
    }}>{`overflow`}</h1>
    <p><strong parentName="p">{`Since :`}</strong>{` UXP v3.0`}</p>
    <p>{`Shorthand which determines what is done with content that overflows the element's bounds.`}</p>
    <p>{`Supports `}<inlineCode parentName="p">{`visible`}</inlineCode>{`, `}<inlineCode parentName="p">{`hidden`}</inlineCode>{`, `}<inlineCode parentName="p">{`auto`}</inlineCode>{`, and `}<inlineCode parentName="p">{`scroll`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/overflow"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/overflow`}</a>{`  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      